module.exports = "././img/roboto-v16-latin-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ../fonts/roboto-v16-latin-regular.ttf
// module id = 830
// module chunks = 0